import React, { useCallback } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { IAccount, IOrder, ResultObjectType } from '@cbgms/api'
import { formatDateTime } from '@cbgms/base/utils/datetime'
import Currency from '@cbgms/components/general/Currency'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import { ResultTitle } from './Title'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() =>
  createStyles({
    pointer: {
      width: '100%',
      cursor: 'pointer'
    }
  })
)

export interface OrderResultType {
  Type: ResultObjectType
  Order: IOrder & Pick<IAccount, 'CompanyName'>
  query: string
  clearQuery: () => void
  primaryAction: () => Promise<void>
  hasGroupHeader: boolean
}

export const MoreOrderResults: React.FC<{ primaryAction: () => Promise<void> }> = ({ primaryAction }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )

  return (
    <Grid
      container
      key='search-order-result-combined'
      className={classes.pointer}
      spacing={0}
      sx={{ margin: 0, padding: 0 }}
      onClick={onClick}
    >
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'inline-flex',
            flexWrap: 'no-wrap',
            alignContent: 'center',
            justifyContent: 'flex-start',
            alignItems: 'center',
            height: '100%',
            '&>*': { flex: '1 1 auto', mr: 1 }
          }}
        >
          <Typography sx={{ pr: 1 }}>{t('search.view_more_order_results')}</Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export const OrderResult: React.FC<OrderResultType> = props => {
  const { Order, Type, hasGroupHeader, primaryAction } = props
  const classes = useStyles()
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )

  return (
    <div className={classes.pointer} onClick={onClick}>
      <Grid container spacing={2}>
        <ResultTitle resultType={Type} isTitleVisible={!hasGroupHeader} />
        <Grid item xs={2}>
          <LocalShippingIcon fontSize='large' />
        </Grid>
        <Grid item xs={10}>
          <Typography variant='body1' component='h3' style={{ fontWeight: 'bold' }}>
            {Order.ID} | {formatDateTime(Order.Timestamp)} | <Currency amount={Order.TotalPriceWhenOrdered} />
          </Typography>
          <Typography component='p'>{Order.CompanyName}</Typography>
        </Grid>
      </Grid>
    </div>
  )
}
